/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Dlh_SubInputs */

const en_wc_dlh_sub = /** @type {(inputs: Wc_Dlh_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose your operating system, then follow our English installation guide. Download buttons point to the WordCraft developers' release files on GitHub.`)
};

/**
* | output |
* | --- |
* | "Choose your operating system, then follow our English installation guide. Download buttons point to the WordCraft developers' release files on GitHub." |
*
* @param {Wc_Dlh_SubInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_dlh_sub = /** @type {((inputs?: Wc_Dlh_SubInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Dlh_SubInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_dlh_sub(inputs)
});
export { wc_dlh_sub as "wc.dlh.sub" }